import React from 'react';
import { PageTitle } from '../../../../rbts/layout/core';
import { Vista } from './components/Vista';

const ReportePVPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Reporte de Puntos de Venta</PageTitle>
      <Vista />
    </>
  );
};

export { ReportePVPage };
